import { useNavigate, useParams } from 'react-router';

export function useCompanyTreeSettingsIdInPathParams() {
  const navigate = useNavigate();

  const { id: companyTreeSettingsIdStr } = useParams<{ id: string }>();
  const companyTreeSettingsId = Number.parseInt(companyTreeSettingsIdStr!, 10);

  if (Number.isNaN(companyTreeSettingsId)) {
    navigate('/companies', { replace: true });
  }
  return companyTreeSettingsId;
}

/**
 * Whether the entity will be synced automatically during the next sync
 */
export function isSyncEnabled(entity: { lastAccessed: string | null }) {
  // only sync automatically if the entity has been accessed in the last two weeks or created in the last two weeks
  const threshold = new Date(Date.now() - 1000 * 60 * 60 * 24 * 14).getTime();

  return (
    entity.lastAccessed && new Date(entity.lastAccessed).getTime() >= threshold
  );
}
